import React from 'react';
import LayoutColumn from './LayoutColumn/Column';
import { Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

const LayoutRow = ({ contentRows, qsOptions }) => (
    <Box component="div">
        {contentRows &&
            contentRows?.map((row, index) => (
                <Grid
                    container
                    direction="row"
                    spacing={1}
                    key={index}
                    style={{ paddingBottom: 5 }}
                >
                    {row.objects &&
                        row.objects.length > 0 &&
                        row.objects.map((object) => (
                            <Grid
                                key={object._id}
                                item
                                sm={object?.size?.sm}
                                xs={object?.size?.xs}
                                md={object?.size?.md}
                            >
                                <LayoutColumn
                                    object={{ ...object, height: row.height }}
                                    qsOptions={qsOptions}
                                />
                            </Grid>
                        ))}
                </Grid>
            ))}
    </Box>
);

LayoutRow.propTypes = {
    contentRows: PropTypes.arrayOf(PropTypes.object).isRequired,
    qsOptions: PropTypes.object.isRequired,
};

export default LayoutRow;
